const COLUMN_ALIGN_RIGHT = {
  cellClass: 'ag-cell-align-right',
  headerClass: 'ag-right-aligned-header',
};

export { COLUMN_ALIGN_RIGHT };
